<template>
  <div class="container-fluid">
    <div class="home">
      <div class="row justify-content-md-center">
        <b-col md="6">
          <h2>Instituto Maha Lilah</h2>
          <p style="text-align: justify; margin-top: 40px;">
            Aqui você encontrará os terapeutas formados por mim, Denise Mascarenhas, no curso de formação de Terapeutas Maha Lilah. 
            Selecione seu estado e confira os terapeutas credenciados da sua cidade.
          </p>
          <router-link to='/terapeutas'>
            <b-button class="find-therapist-button" variant="outline-dark">
              Quero encontrar um terapeuta credenciado
            </b-button>
          </router-link>
          <video 
            ref="video"
            muted
            preload
            width="100%"
            controls
            currentTime="5"
            playsinline="true" 
            src="https://video.wixstatic.com/video/c85369_13a3ca6ef89b4aeb8423d28e6a931489/720p/mp4/file.mp4" 
            class="">
          </video>
        </b-col>
      </div>
    </div>

    <app-footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import AppFooter from '../components/AppFooter.vue'

export default {
  name: 'Home',
  components: {
    AppFooter
  },
  mounted() {
    this.$refs.video.currentTime = 1;
  }
}
</script>

<style scoped>

.find-therapist-button {
  background-color: gray;
  color: white;
  border-color: black;
}

.find-therapist-button:hover {
  background-color: #f8f4ef;
  color: black;
  border-color: black;
}


.home {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 40px 101px;
  color: #000 !important;
  background-color: #f8f4ef;
}


video {
  max-width: 100%;
  height: auto;
  margin-top: 30px;
}


</style>